<!--
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2019-09-16 10:33:05
 * @LastEditors: 陈钊贤
 * @Description: 充电时如果修改车牌（链接上 str=oldCarNumber），修改的是用户信息里 old 车牌，点击默认车牌，就是把 old 的值修改为默认车牌的值（也就是两个值都一样）
                 个人信息修改车牌就是仅仅修改默认车牌（链接上 str=carNumber）
 * @LastEditTime: 2021-04-13 14:08:34
 -->
<template>
  <pi-content :name="pageName" class="my-license-plate-add">
    <div class="input-box">
      <!-- <div class="car-more"
           v-if="defaultShow"
           @click="defaultCar">选择默认车牌
      </div> -->
      
      <div class="box-div">
        <div class="item-flex"
             @click="popupVisible = true">{{form.name}}
        </div>
        <div class="item-flex"
             @click="letterShow = true">{{form.area}}
        </div>
        <div class="v-center">
          <div class="dian"></div>
        </div>
        <div @click="itemClick(item)"
             class="item-flex"
             v-for="(item) in 6"
             :key="item"
             :class="{'active' : item == form.value.length || item == 1 && form.value.length==0}">
          <!-- <span v-if="item == 6 && !form.value.split('')[item -1]">新</span> -->
          <span v-if="form.value.split('')[item -1]"
                class="black">{{form.value.split('')[item -1]}}</span>
        </div>
      </div>
      <!-- <div class="vin-input-box">
        <input type="text" v-model="form.carNo" placeholder="请输入车牌" maxlength="8">
      </div> -->
      <div class="vin-input-box">
        <input type="text" v-model="form.vin" placeholder="请输入VIN码(车架号)">
      </div>
      <!-- <div class="word" @click="popupVisible = true">{{form.name}}</div>
        <div class="v-center icon-div"><img class="icon" src="@/assets/img/icon-right.png" alt=""></div>
        <div class="flex">
            <input type="text" name="" v-model="form.value" id="" maxlength="6">
        </div> -->
    </div>
    <div class="btn-box">
      <pi-button type="primary"
                 block
                 @click="subData">确定
      </pi-button>
    </div>

    <mt-popup v-model="popupVisible"
              position="bottom">
      <div class="popup-box">
        <ul class="word-list">
          <li class="word-item"
              @click="wordClick(item)"
              :key="index"
              :class="{'active' : form.name == item}"
              v-for="(item,index) in provinces ">{{item}}
          </li>
        </ul>
      </div>
    </mt-popup>
    <mt-popup v-model="letterShow"
              position="bottom">
      <div class="popup-box">
        <ul class="word-list">
          <li class="word-item"
              @click="letterClick(item)"
              :key="index"
              :class="{'active' : form.area == item}"
              v-for="(item,index) in letter ">{{item}}
          </li>
          <!-- <li class="word-item"
              @click="letterClick(item)"
              :key="index+item"
              :class="{'active' : form.area == item}"
              v-for="(item,index) in letterOther ">{{item}}
          </li> -->

        </ul>
      </div>
    </mt-popup>
    <mt-popup v-model="valueShow"
              position="bottom">
      <div class="popup-box">
        <ul class="word-list">
          <li class="word-item"
              @click="valueClick(item)"
              :key="item+index"
              v-for="(item,index) in number ">{{item}}
          </li>
          <li class="word-item"
              @click="valueClick(item)"
              :key="item+index"
              v-for="(item,index) in letter ">{{item}}
          </li>
          <template v-if="form.value.length >= 4">
            <li class="word-item"
                @click="valueClick(item)"
                :key="index+item"
                :class="{'active' : form.area == item}"
                v-for="(item,index) in letterOther ">{{item}}
            </li>
          </template>
          <li class="word-item remove"
              @click="removeValue">删
          </li>
        </ul>
      </div>
    </mt-popup>
  </pi-content>
</template>

<script>
// import { updateUserCarinfo } from '@/config/api/index';
import { mapState, mapMutations } from 'vuex';
import { getUserBaseInfo, addCar, upCar} from '../../common/api';
import { Toast, Popup } from 'vant';

export default {
  name: 'my-licensePlate',
  data () {
    return {
      // cardInputShow:false,
      popupVisible: false,
      provinces: ['京', '沪', '浙', '苏', '粤', '鲁', '晋', '冀',
        '豫', '川', '渝', '辽', '吉', '黑', '皖', '鄂',
        '津', '贵', '云', '桂', '琼', '青', '新', '藏',
        '蒙', '宁', '甘', '陕', '闽', '赣', '湘','新','使','警','北','深','无'],
      letter: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K', 'L', 'M', 'N', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
      letterOther: ['警', '港', '澳', '学','领'],
      number: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
      letterShow: false,
      valueShow: false,
      form: {
        name: '粤',
        area: 'B',
        value: '',
        vin: '',
        carNo:''
      },
      str: '',
      strIndex: 0,
      pageName: '我的车牌',
      defaultShow: false,
      userinfo: null,
    };
  },
  methods: {
    getUserBaseData () {
      getUserBaseInfo(null, true).then(response => {
        if (response.status == this.$config.ajaxStatus && response.data.length > 0) {
          this.userinfo = response.data[0];
          this.initData();
        }
      })
    },
    wordClick (item) {
      this.form.name = item;
      this.popupVisible = false;
    },
    letterClick (item) {
      this.form.area = item;
      this.letterShow = false;
    },
    valueClick (item) {
      if (this.form.value.length < 6) {
        this.form.value = this.form.value + item;
      }
      if (this.form.value.length === 6) {
        this.valueShow = false;
      }
    },
    removeValue () {
      this.form.value = this.form.value.slice(0, this.form.value.length - 1);
    },
    itemClick (item, index) {
      this.strIndex = index;
      this.valueShow = true;
    },
    async subData () {
      if (this.form.name === '' || this.form.value === '') {
        this.$toast('请输入车牌');
      } else if (this.form.value.length < 5) {
        this.$toast('车牌长度不对');
      } else {
        this.saveUserBaseInfo(this.form.name + this.form.area + this.form.value);
      }
      // if (this.form.carNo === '') {
      //   this.$toast('请输入车牌');
      // }else if (this.form.carNo.length< 7) {
      //   this.$toast('请输入车牌7位或8位的车牌号码');
      // } else {
      //   this.saveUserBaseInfo(this.form.carNo);
      // }
      
    },
    // defaultCar () {
    //   this.carInput('carNumber', 1);
    //   this.subData();
    // },
    carInput (car) {
      this.form.name = car.slice(0, 1);
      this.form.area = car.slice(1, 2);
      this.form.value = car.slice(2, car.length);
    },
    saveUserBaseInfo (carCradString) {

      if (carCradString.length <= 1) {
        Toast('车牌号不能为空');
        return;
      }
      let that = this;
      let ret = '';
      if(this.form.pkid){
        ret = upCar({
          carNo: carCradString,
          vin: this.form.vin,
          pkid: this.form.pkid,
        })
      }else{
        ret = addCar({
          carNo: carCradString,
          vin: this.form.vin
        })
      }
      ret.then((response) => {
        if (response.status == this.$config.ajaxStatus) {
          Toast.clear();
          Toast('车牌信息更新成功');
          that.$router.back(-1);
        }else{
          Toast(response.msg);
        }
      }).catch(function(error) {
        Toast.clear();
        Toast('车牌信息更新失败');
        console.log(error);
      });

      // saveUserBaseInfo({
      //     carNo: carCradString,
      //     phoneNo: that.userinfo.phoneNo,
      //     sex: that.userinfo.sex,
      //     userName: that.userinfo.userName,
      //     userPkId: that.userinfo.userPkId,
      //     vinNo: that.userinfo.vinNo,
      //   }, true
      // ).then((response) => {
      //   if (response.status == this.$config.ajaxStatus) {
      //     console.log(response);
      //     Toast.clear();
      //     Toast('车牌信息更新成功');
      //     that.$router.back(-1);
      //   }
      // }).catch(function(error) {
      //   Toast.clear();
      //   Toast('车牌信息更新失败');
      //   console.log(error);
      // });
    },
    initData(){
      if(this.userinfo.carNo && this.userinfo.carNo != ''){
        let car = this.userinfo.carNo;
        this.form.name = car.slice(0, 1);
          this.form.area = car.slice(1, 2);
          this.form.value = car.slice(2, car.length);
      }
    },
    ...mapMutations(['MERGE_USERINFO'])
  },
  mounted () {
    // let userinfo = this.$route.query.param;
    // if(userinfo){
    //   this.userinfo = JSON.parse(userinfo);
    //   this.initData();
    // }else{
      // this.getUserBaseData();
      
    // }
    
    let query = this.$route.query
    if(query && query.pkid){
      this.form.pkid = query.pkid;
      this.form.vin = query.vin;
      // this.form.carNo = query.carNo;
      this.carInput(query.carNo);
    }

    // let type = this.$common.query('type');
    // if (type === 'select') {
    //   if (str === 'oldCarNumber' && this.app.userInfo.carNumber === '') {
    //     str = 'carNumber';
    //   } else if (this.app.userInfo.carNumber !== '' && this.app.userInfo.oldCarNumber !== '') {
    //     this.defaultShow = true;
    //   }
    // }
    // if (str && str !== '') {
    //   this.carInput(str);
    // }
  },

  computed: {
    ...mapState(['app'])
  },
  components: {
    'mt-popup': Popup,
    [Toast.name]: Toast
  }
};
</script>

<style lang="less">
@import "../../assets/less/old/var";
.my-license-plate-add{
  .van-overlay{
      background: transparent;
    }
  .input-box {
    padding-top: 0.48rem;
    padding-left: 0.35rem;
    padding-right: 0.35rem;
    color: #000;
    font-size: 0.4rem;
    position: relative;
    
    .car-more {
      position: absolute;
      top: 1rem;
      right: 0.3rem;
      color: @main-color;
      .size;
    }

    // line-height: 0.44rem;
    .box-div {
      display: flex;

      .item-flex {
        width: 0.66rem;
        height: 0.8rem;
        line-height: 0.8rem;
        text-align: center;
        border: 0.02rem solid #c3c2c2;
        border-radius: 0.12rem;
        margin-left: 0.14rem;
      }

      .item-flex:first-child {
        margin-left: 0;
      }

      .item-flex.active {
        border-color: @main-color;
      }

      // .item-flex:last-child {
      //   color: #d5d5d5;
      //   background: rgba(20, 205, 127, 0.1);
      //   border-color: rgba(20, 205, 127, 0.4);
      //   font-weight: normal;

      //   .black {
      //     color: #000;
      //   }
      // }

      .dian {
        width: 0.16rem;
        height: 0.16rem;
        border-radius: 50%;
        background-color: #c3c2c2;
        margin-left: 0.08rem;
      }
    }

    .vin-input-box{
      margin-top: 0.3rem;
      border: 0.02rem solid #C3C2C2;
      border-radius: 0.12rem;
      padding: 0.2rem;
      height: 0.8rem;
      box-sizing: border-box;
      input{
        height: 0.4rem;
        font-size: 0.28rem;
        vertical-align: top;
      }
    }

    .icon-div {
      padding-left: 0.1rem;
      padding-right: 0.2rem;
    }

    .icon {
      width: 0.35rem;
      position: relative;
      top: -0.05rem;
      transform: rotate(90deg);
    }

    .flex {
      padding-left: 0.2rem;

      border-left: @border;

      input {
        letter-spacing: 0.18rem;
        color: #000;
        font-size: 0.4rem;
        line-height: 0.44rem;
        width: 100%;
      }
    }
  }

  .btn-box {
    margin-top: 0.4rem;
    padding: 0 0.2rem;
  }

  .word-list {
    padding: 0.3rem 0.02rem 0 0.052rem;
    background-color: #f0f0f0;
    display: flex;
    flex-wrap: wrap;

    .word-item {
      width: 0.6rem;
      padding: 0.2rem 0;
      color: #000;
      font-size: 0.4rem;
      line-height: 0.44rem;
      text-align: center;
      background: #ffffff;
      box-shadow: 0 0.02rem 0.04rem 0 rgba(0, 0, 0, 0.5);
      border-radius: 0.04rem;
      margin-left: 0.3rem;
      margin-bottom: 0.4rem;
    }

    .word-item.active {
      background: rgba(0, 0, 0, 0.3);
    }

    .word-item:active {
      background: rgba(0, 0, 0, 0.3);
    }

    .word-item.remove {
      position: absolute;
      right: 0.25rem;
      bottom: 0;
      background: #f2f2f2;
      color: #F95450;
    }
  }
}
</style>
